import { useStaticQuery, graphql } from "gatsby"

export const useChapterData = () => {
	const data = useStaticQuery(graphql`
		{
			chapter1: strapiChapter(chapter_number: { eq: 1 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
			}
			chapter2: strapiChapter(chapter_number: { eq: 2 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter3: strapiChapter(chapter_number: { eq: 3 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter4: strapiChapter(chapter_number: { eq: 4 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				video_url
				text_block {
					text_block_editor
				}
			}
			chapter5: strapiChapter(chapter_number: { eq: 5 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter6: strapiChapter(chapter_number: { eq: 6 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter7: strapiChapter(chapter_number: { eq: 7 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter8: strapiChapter(chapter_number: { eq: 8 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter9: strapiChapter(chapter_number: { eq: 9 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter10: strapiChapter(chapter_number: { eq: 10 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
				frontline {
					Name
					Title
					body
				}
			}
			chapter11: strapiChapter(chapter_number: { eq: 11 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter12: strapiChapter(chapter_number: { eq: 12 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter13: strapiChapter(chapter_number: { eq: 13 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				video_url
				text_block {
					text_block_editor
				}
			}
			chapter14: strapiChapter(chapter_number: { eq: 14 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter15: strapiChapter(chapter_number: { eq: 15 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter16: strapiChapter(chapter_number: { eq: 16 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter17: strapiChapter(chapter_number: { eq: 17 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				video_url
				text_block {
					text_block_editor
				}
			}
			chapter18: strapiChapter(chapter_number: { eq: 18 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter19: strapiChapter(chapter_number: { eq: 19 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
				text_block {
					text_block_editor
				}
			}
			chapter20: strapiChapter(chapter_number: { eq: 20 }) {
				UID
				chapter_nav_title
				chapter_number
				chapter_title
			}
		}
	`)
	return data
}